module.exports = "img/flags/KR.7e83001.png";